import React from 'react';
import styles from "./SelectedChannelName.module.css";
import { SelectedChannelContext } from "../../context/channel/SelectedChannelContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

function SelectedChannelName() {
    const { data, canGoBack, canGoForward, goBack, goForward } = React.useContext(SelectedChannelContext);

    if (data == null) {
        return null;
    }

    return (
        <div className={styles.centered}>
            <button
                className={`${styles.navButton} ${!canGoBack ? styles.disabled : ''}`}
                onClick={goBack}
                disabled={!canGoBack}
                title="Forrige kanal"
                aria-label="Forrige kanal"
            >
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className={styles.name}>{data.name}</div>
            <button
                className={`${styles.navButton} ${!canGoForward ? styles.disabled : ''}`}
                onClick={goForward}
                disabled={!canGoForward}
                title="Neste kanal"
                aria-label="Neste kanal"
            >
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
    );
}

export default SelectedChannelName;
